export default __webpack_public_path__ + "static/media/alex8.a7e945e2.jpg";